import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2022-02-24 18:33:17
 * @LastEditTime: 2022-03-20 13:58:01
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import ReactDOM from 'react-dom';
import mappings from '@/components';
import { store } from '@/store';
import { POSTMESSAGE_PARAMS } from '@/constants';
import App from './components/App';
import 'zarm/dist/zarm.css';
import 'za-dmg-components/dist/index.css';
import './app.less';
import { getHistory } from './history';
const IM = {
  off(evnetName, callback) {
    window.self.removeEventListener(evnetName, callback, false);
  },

  on(evnetName, callback) {
    window.self.addEventListener(evnetName, callback, false);
  },

  postMessage: data => {
    window.parent.postMessage(data, POSTMESSAGE_PARAMS);
  }
};
const Gs = {
  componentMap: _objectSpread({}, mappings),
  history: null,
  _routes: [],
  IM,
  IMessageEventMap: {},
  store,
  config: {
    basePath: '/',
    pdfUrl: 'https://cdn-static.zhongan.io/index.html',
    FLOW_CONFIG: 'http://za-dplatform-flow-h5.uat.za-tech.net',
    EYEJSURL: 'https://staticdaily.zhongan.com/website/isee-poc/eye.js',
    imgUrl: 'https://cdn-static.zhongan.io/image.html'
  },

  addIMEevent(name, fn) {
    if (!this.IMessageEventMap[name]) {
      this.IMessageEventMap[name] = fn;
    } else {
      console.warn(`事件${name}已经存在`);
    }
  },

  start: () => {
    Gs.history = getHistory();
    ReactDOM.render( /*#__PURE__*/React.createElement(App, null), document.getElementById('root'));
  },

  setConfig({
    components
  }) {
    this.componentMap = _objectSpread(_objectSpread({}, this.componentMap), components);
  },

  addRoute(path, component) {
    this._routes.push({
      path,
      component
    });
  },

  register(name, fn, flag = false) {
    if (!this.componentMap[name] || flag) {
      this.componentMap[name] = fn;
    } else {
      console.warn(`组件${name}已经存在`);
    }
  }

};
const {
  dispatch
} = store;
Gs.addIMEevent('allPageConfig', eventDate => {
  const {
    data
  } = eventDate;
  dispatch({
    type: 'configJson',
    payload: {
      configJson: data
    }
  });
});
Gs.addIMEevent('activePage', eventDate => {
  const {
    data
  } = eventDate;
  dispatch({
    type: 'setPageNum',
    payload: {
      pageIndex: data
    }
  });
});
Gs.addIMEevent('pageConfig', eventDate => {
  const {
    data
  } = eventDate;
  dispatch({
    type: 'set',
    payload: {
      currentPageJson: data
    }
  });
});
Gs.addIMEevent('behavior', data => {
  if (!data) {
    return;
  }

  const {
    type,
    data: {
      showModalModule = []
    } = {}
  } = data; // const [modal] = showModalModule;

  if (data.data.currentPlan) {
    dispatch({
      type: 'set',
      payload: {
        PLAN_ID: data.data.currentPlan - 0,
        currentPlan: data.data.currentPlan - 0
      }
    });
  }

  if (type !== 'behavior') {
    return;
  }
});
Gs.addIMEevent('changeColor', data => {
  if (!data) {
    return;
  }

  const {
    data: themes
  } = data;

  if (themes && themes.primaryColor) {
    localStorage.setItem('themeColor', themes.primaryColor);
    document.documentElement.style.setProperty('--theme-primary', themes.primaryColor);
  }
});
Gs.addIMEevent('activeModuleId', eventDate => {
  const {
    data
  } = eventDate;
  dispatch({
    type: 'set',
    payload: {
      activeModuleId: data
    }
  });
});
export default Gs;